import { render, staticRenderFns } from "./SiteDash.vue?vue&type=template&id=6b54cc1e&scoped=true&"
import script from "./SiteDash.vue?vue&type=script&lang=js&"
export * from "./SiteDash.vue?vue&type=script&lang=js&"
import style0 from "./SiteDash.vue?vue&type=style&index=0&id=6b54cc1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54cc1e",
  null
  
)

export default component.exports